import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import ImageMonoHtmlView from './ImageHtml';
import ImageMonoReactView from './Image';
const ImageMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(ImageMonoHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(ImageMonoReactView, _extends({}, props));
};
ImageMonoView.displayName = 'ImageMonoView';
export default ImageMonoView;
